import Beans3 from '@/beans';

import WooCommerceRadix from './radix/woocommerce';

if (!Beans3._utils.isBrowserSupported()) {
  console.error('This browser does not support Beans..');
} else if (!Beans3._cache.get('launched__ultimate')) {
  Beans3._cache.set('launched__ultimate', true);
  Beans3._utils.loadCSS('beans-ultimate-css', '$$CSS_FILE$$');

  const args = Beans3._utils.getCurrentScriptArgs();
  args.id = args.id || window.beans_card;
  args.domainAPI = '$$DOMAIN_API$$';
  Beans3.init(args);
  Beans3._trellis = 'woocommerce';
  Beans3._trellis_version = args.trellis_version;
  Beans3._cache.set('auth-merchant-id', args.beans_card_id || args.id || '');

  window.Beans3 = window.Beans3 || Beans3;
  window.Beans3.Radix = WooCommerceRadix;

  if (typeof window.beans_init_data !== 'undefined') {
    // This likely means that the script has been loaded as deferred
    // Check issue CR-183
    WooCommerceRadix.init();
  }
}
